import React, { useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import json from 'react-syntax-highlighter/dist/cjs/languages/prism/json';

import Styles from './LogTextHighlighter.styles';

const defaultLineNumberStyles = {
  textAlign: 'right',
  float: 'left',
  paddingRight: '11px',
};

const LogTextHighlighter = ({
  className,
  labelClassName,
  lineNumberStyles,
  maxColorLogSize,
  label,
  showLineNumbers,
  httpStatus,
  text,
  useInlineStyles,
}) => {
  useEffect(() => {
    SyntaxHighlighter.registerLanguage('json', json);
  }, []);
  return (
    <>
      <div className={labelClassName}>
        {label}
      </div>
      <div className={classNames(Styles.log, className)}>
        {httpStatus}
        {text.length <= maxColorLogSize ? (
          <SyntaxHighlighter
            className={Styles.formatted}
            language="json"
            lineNumberContainerStyle={lineNumberStyles}
            showLineNumbers={showLineNumbers}
            useInlineStyles={useInlineStyles}
          >
            {text}
          </SyntaxHighlighter>
        ) : text}
      </div>
    </>
  );
};

LogTextHighlighter.propTypes = {
  className: PropTypes.string,
  httpStatus: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  lineNumberStyles: PropTypes.object,
  maxColorLogSize: PropTypes.number, // 100kB
  showLineNumbers: PropTypes.bool,
  text: PropTypes.string.isRequired,
  useInlineStyles: PropTypes.bool,
};

LogTextHighlighter.defaultProps = {
  className: '',
  httpStatus: '',
  labelClassName: 'label',
  lineNumberStyles: defaultLineNumberStyles,
  maxColorLogSize: 100000, // 100kB
  showLineNumbers: true,
  useInlineStyles: false,
};

export default LogTextHighlighter;
